// Dependencies
import React, { Component } from 'react';
import PageTitleComponent from '../../components/page-title/page-title';
import ProfessionalNameComponent from '../../components/products/professional-name/professional-name';
import CedulaComponent from '../../components/products/cedula/cedula';
import GoodStandingComponent from '../../components/products/good-standing/good-standing';
import CertidaoDiretivaComponent from '../../components/products/certidao-diretiva/certidao-diretiva';
import VinhetasComponent from '../../components/products/vinhetas/vinhetas';
import CertidaoNaoSubmissaoComponent from '../../components/products/certidao-nao-submissao/certidao-nao-submissao';
import LevantamentoSuspensaoComponent from '../../components/products/levantamento-suspensao/levantamento-suspensao';
import PedidoSuspensaoComponent from '../../components/products/pedido-suspensao/pedido-suspensao';
import { isMobileOnly } from 'react-device-detect';

// Primereact imports
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './products.scss';

// Security
import { authenticationChecker } from '../../components/security/authentication-checker';

// Redux
import { connect } from 'react-redux';
import StoreService from '../../redux/services/store';

// Utils
import { CEDULA_COM_ENTREGA_PRODUCT, CEDULA_SEM_ENTREGA_PRODUCT, CERTIDAO_DIRETIVA_PRODUCT, CERTIDAO_NAO_SUBMISSAO_PRODUCT, CERTIDAO_SITUACAO_REGULAR_PRODUCT, CERTIDAO_SUBMISSAO_PRODUCT, DECLARACAO_SEGURO_PRODUCT, GOOD_STANDING_PRODUCT, LEVANTAMENTO_SUSPENSAO_PRODUCT, MUDANCA_NOME_PROFISSIONAL_PRODUCT, PEDIDO_SUSPENSAO_PRODUCT, REGISTRATION_STATE_APPROVED, REGISTRATION_STATE_SUSPENDED, VINHETAS_DIGITAL_PRODUCT, VINHETAS_PAPEL_PRODUCT } from '../../common/constants';
import { updateBasket } from '../../redux/actions/order';
import QuoteService from '../../redux/services/quote';
import { Link } from 'react-router-dom';
import { Badge } from 'primereact/badge';

class ProductsPage extends Component {

    constructor(props) {
        super(props);
        this._toast = React.createRef();
        this.state = {
            selectedProduct: null,
            products: [],
            quoteFee: null,
        };
    }

    componentDidMount() {
        const formProducts = this.props.registrationState !== null && this.props.registrationState !== REGISTRATION_STATE_APPROVED && this.props.registrationState !== REGISTRATION_STATE_SUSPENDED;
        const membersAreaProducts = this.props.registrationState !== null && this.props.registrationState === REGISTRATION_STATE_APPROVED || this.props.registrationState === REGISTRATION_STATE_SUSPENDED;
        const activeRegistrationProducts = this.props.registrationState !== null && this.props.registrationState === REGISTRATION_STATE_APPROVED;

        StoreService.getActiveProducts(formProducts, membersAreaProducts, activeRegistrationProducts).then((response) => { 
            this.setState({
                products: response.products
            })
        })
        .catch(error => {
            this._toast.current.show({ severity: 'error', detail: this.props.t("products.messages.error"), life: 3000 });
        });

        QuoteService.getAssociateMissingQuotesFees(this.props.associate.associateId)
        .then((response) => { 
            this.setState({
                quoteFee: response.quoteFee
            });
        })
        .catch(error => { });
    }

    checkProductAvailability(productRef) {
        for (let i = 0; i < this.props.basketProducts.length; i++) {
            if(this.props.basketProducts[i].productRef === productRef) {
                return false;
            }            
        }

        return true;
    }

    selectProduct(product) {
        this.setState({selectedProduct: product});

        if(product.productRef === DECLARACAO_SEGURO_PRODUCT || product.productRef === CERTIDAO_SUBMISSAO_PRODUCT) {
            let products = [];

            for (let i = 0; i < this.props.basketProducts.length; i++) {
                products.push(this.props.basketProducts[i]);
            }

            product.title = this.props.t("products.products." + product.title);

            products.push(product);
            this.props.updateBasket(products, this.props.basketTrainings);

            this.addProductToBasketCallback();
        }

        if(product.productRef === CERTIDAO_SITUACAO_REGULAR_PRODUCT) {
            let validQuotePayment = this.state.quoteFee === null || (this.state.quoteFee !== null && this.state.quoteFee.delayMonths === 0);

            if(validQuotePayment) {
                let products = [];

                for (let i = 0; i < this.props.basketProducts.length; i++) {
                    products.push(this.props.basketProducts[i]);
                }

                products.push(product);
                this.props.updateBasket(products, this.props.basketTrainings);

                this.addProductToBasketCallback();
            }
            else {
                this._toast.current.show({ severity: 'error', detail: this.props.t("products.messages.quotes-to-pay"), life: 3000 });
            }
        }
    }

    addProductToBasketCallback() {
        this.setState({
            selectedProduct: null
        });

        window.scrollTo(0, 0);
        this._toast.current.show({ severity: 'success', detail: this.props.t("products.messages.product-added"), life: 3000 });
    }

    getProductTitle(productRef) {
        for (let i = 0; i < this.state.products.length; i++) {
            if(this.state.products[i].productRef === productRef) {
                return this.props.t("products.products." + this.state.products[i].title);
            }
        }

        return "";
    }

    render() {

       return (
            <div>
                <div>
                    {
                        localStorage.getItem('Hideinapp') === "1" ?
                            <div className="grid" style={{minHeight:"60px", alignItems:"center", background: "#0073AA", textAlign: "left"}}>
                                <div className="col-1"></div>
                                <div className="col-6">
                                    <span style={{color:"#FFFFFF", fontSize:"18px"}}>{this.props.t("products.title")}</span>
                                </div>
                                <div className="col-4 t-align-right" style={{paddingRight: "20px"}}>
                                    <Link to={process.env.PUBLIC_URL + "/checkout"}>
                                        {
                                            this.props.basketProducts.length === 0 ?
                                                <i className="pi pi-shopping-cart c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}></i>
                                                :
                                                <i className="pi pi-shopping-cart p-overlay-badge c-pointer" style={{ color: "#ffffff", fontSize: '1.9rem' }} title={this.props.t("checkout.menu")}>
                                                    <Badge style={{ borderColor: "#ffffff" }} value={this.props.basketProducts.length}></Badge>
                                                </i>
                                        }
                                    </Link>
                                </div>
                                <div className="col-1"></div>
                            </div>
                            :
                            <PageTitleComponent title={this.props.t("products.title")} />
                    }
                </div>
                <div className={isMobileOnly ? 'grid mgb-20' : 'grid mgb-80'}>
                    <div className='col-1'></div>
                    <div className="col-10"> 
                        <div className='grid container mgt-20'>
                            {this.state.products.map((product) => {
                                return (
                                    <div key={product.productRef} className="col-12 md:col-12 lg:col-3">
                                        <Card style={{color: "#0073aa", display: "flex", flexWrap: "wrap", alignContent: "space-between", flexDirection: "column"}} 
                                              title={this.props.t("products.products." + product.title)}
                                              subTitle={product.subtitle !== null ? this.props.t("products.products." + product.subtitle) : null}
                                              footer={ <div className='grid' style={{marginTop: this.props.t("products.products." + product.title).length < 30 && (product.subtitle === null || product.subtitle === "") ? "40px" : "0px"}}>
                                                            <div style={{paddingTop: "15px"}} className='col-6 t-align-left'>
                                                                <b style={{fontSize: "16px", marginTop: "10px", marginLeft: "10px"}}>{product.price === null ? this.props.t("products.labels.free") : product.price + "€"}</b>
                                                            </div>
                                                            <div className='col-6 t-align-right'>
                                                                <div className="flex flex-wrap justify-content-end gap-2">
                                                                    <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" disabled={!this.checkProductAvailability(product.productRef)} onClick={(evt) => this.selectProduct(product)} />
                                                                </div>
                                                            </div>
                                                        </div>} 
                                              header={<img alt="Card" src={"data:image/jpeg;base64," + product.picture} />} 
                                              className="md:w-25rem">
                                            <p className="m-0">
                                            </p>
                                        </Card>
                                    </div>
                                );
                            })}
                        </div>  
                        <div className='grid container mgt-20 mgb-30'>
                            <div className="col-12 md:col-12 lg:col-12 t-align-center">
                                <Button className='p-button-success' style={{fontSize: "20px"}} label={this.props.t("checkout.messages.close")} onClick={() => window.open(process.env.PUBLIC_URL + "/checkout", "_self")}  />
                            </div>
                        </div>  
                    </div>
                    <div className='col-1'></div>
                </div>
                {
                    this.state.selectedProduct !== null ?
                    <>
                        <Dialog visible={this.state.selectedProduct.productRef  === MUDANCA_NOME_PROFISSIONAL_PRODUCT} style={{ width: '450px' }} header={this.getProductTitle(MUDANCA_NOME_PROFISSIONAL_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <ProfessionalNameComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()}/>
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === CEDULA_SEM_ENTREGA_PRODUCT} style={{ width: '550px' }} header={this.getProductTitle(CEDULA_SEM_ENTREGA_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <CedulaComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()} onCancel={() => this.setState({selectedProduct: null})} />
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === CEDULA_COM_ENTREGA_PRODUCT} style={{ width: '550px' }} header={this.getProductTitle(CEDULA_COM_ENTREGA_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <CedulaComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()} onCancel={() => this.setState({selectedProduct: null})} />
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === GOOD_STANDING_PRODUCT} style={{ width: '450px' }} header={this.getProductTitle(GOOD_STANDING_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <GoodStandingComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()} />
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === CERTIDAO_DIRETIVA_PRODUCT} style={{ width: '450px' }} header={this.getProductTitle(CERTIDAO_DIRETIVA_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <CertidaoDiretivaComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()}/>
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === VINHETAS_PAPEL_PRODUCT} style={{ width: '450px' }} header={this.getProductTitle(VINHETAS_PAPEL_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <VinhetasComponent product={this.state.selectedProduct} format="Papel" onClose={() => this.addProductToBasketCallback() }/>
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === VINHETAS_DIGITAL_PRODUCT} style={{ width: '450px' }} header={this.getProductTitle(VINHETAS_DIGITAL_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <VinhetasComponent product={this.state.selectedProduct} format="Digital" onClose={() => this.addProductToBasketCallback() }/>
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === CERTIDAO_NAO_SUBMISSAO_PRODUCT} style={{ width: '650px' }} header={this.getProductTitle(CERTIDAO_NAO_SUBMISSAO_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <CertidaoNaoSubmissaoComponent product={this.state.selectedProduct} onClose={() => this.addProductToBasketCallback()} />
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === LEVANTAMENTO_SUSPENSAO_PRODUCT} style={{ width: '500px' }} header={this.getProductTitle(LEVANTAMENTO_SUSPENSAO_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <LevantamentoSuspensaoComponent product={this.state.selectedProduct} associate={this.props.associate} ballot={this.props.ballot} onClose={() => this.addProductToBasketCallback()} />
                        </Dialog>
                        <Dialog visible={this.state.selectedProduct.productRef === PEDIDO_SUSPENSAO_PRODUCT} style={{ width: '600px' }} header={this.getProductTitle(PEDIDO_SUSPENSAO_PRODUCT)} modal onHide={() => this.setState({selectedProduct: null}) }>
                            <PedidoSuspensaoComponent product={this.state.selectedProduct} ballot={this.props.ballot} associate={this.props.associate} onClose={() => this.addProductToBasketCallback()} />
                        </Dialog>
                    </>
                    :
                    null
                }
                <Toast position='bottom-left' ref={this._toast} />
            </div>
        );
  }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        ballot: state.profile.ballot,
        registrationState: state.authentication.registrationState,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};
  

export default connect(mapStateToProps, mapDispatchToProps)(authenticationChecker(withTranslation(ProductsPage)));